"use strict";

var _regeneratorRuntime = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _classCallCheck = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var tweetnacl_1 = __importDefault(require("tweetnacl"));

var tweetnacl_util_1 = __importDefault(require("tweetnacl-util"));

var hdnode_1 = require("@ethersproject/hdnode");

var wallet_1 = require("@ethersproject/wallet");

var did_jwt_1 = require("did-jwt");

var js_sha256_1 = require("js-sha256");

var elliptic_1 = require("elliptic");

var crypto_1 = require("./crypto");

var utils_1 = require("./utils");

var ec = new elliptic_1.ec('secp256k1');
var BASE_PATH = "m/51073068'/0'";
var ROOT_STORE_PATH = "0'/0'/0'/0'/0'/0'/0'/0'";
var BASE_PATH_LEGACY = "m/7696500'/0'/0'";
var AUTH_PATH_WALLET = BASE_PATH + '/' + ROOT_STORE_PATH + '/0';
var AUTH_PATH_ENCRYPTION = BASE_PATH + '/' + ROOT_STORE_PATH + '/3';

var ensure0x = function ensure0x(str) {
  return (str.startsWith('0x') ? '' : '0x') + str;
};

var Keyring = /*#__PURE__*/function () {
  function Keyring(seed, migratedKeys) {
    _classCallCheck(this, Keyring);

    this._spaceKeys = {};
    this._migratedKeys = false;

    if (seed) {
      this._seed = seed;
      this._baseNode = hdnode_1.HDNode.fromSeed(this._seed).derivePath(BASE_PATH);

      var rootNode = this._baseNode.derivePath(ROOT_STORE_PATH);

      this._rootKeys = this._deriveRootKeySet(rootNode);
    }

    if (migratedKeys) {
      this._migratedKeys = true;

      this._importMigratedKeys(migratedKeys);
    }

    if (!(seed || migratedKeys)) throw new Error('One or both of seed or migratedKeys required');
  }

  _createClass(Keyring, [{
    key: "_importMigratedKeys",
    value: function _importMigratedKeys(migratedKeysString) {
      var _this = this;

      var migratedKeys = JSON.parse(migratedKeysString);

      var getHDNode = function getHDNode(seed) {
        var seedNode = hdnode_1.HDNode.fromSeed(seed);
        return seedNode.derivePath(BASE_PATH_LEGACY);
      };

      var rootNode = getHDNode(migratedKeys.seed);
      this._rootKeys = this._deriveRootKeySet(rootNode);
      this._rootKeys.managementAddress = migratedKeys.managementAddress;
      this._rootKeys.managementKey = {
        address: migratedKeys.managementAddress
      };
      Object.keys(migratedKeys.spaceSeeds).map(function (name) {
        var spaceNode = getHDNode(migratedKeys.spaceSeeds[name]);
        _this._spaceKeys[name] = _this._deriveKeySet(spaceNode);
      });
    }
  }, {
    key: "_deriveKeySet",
    value: function _deriveKeySet(hdNode) {
      return {
        signingKey: hdNode.derivePath('0'),
        asymEncryptionKey: tweetnacl_1.default.box.keyPair.fromSecretKey(new Uint8Array(Buffer.from(hdNode.derivePath('2').privateKey.slice(2), 'hex'))),
        symEncryptionKey: utils_1.hexToUint8Array(hdNode.derivePath('3').privateKey.slice(2))
      };
    }
  }, {
    key: "_deriveRootKeySet",
    value: function _deriveRootKeySet(hdNode) {
      return Object.assign(Object.assign({}, this._deriveKeySet(hdNode)), {
        managementKey: hdNode.derivePath('1')
      });
    }
  }, {
    key: "_deriveSpaceKeys",
    value: function _deriveSpaceKeys(space) {
      var _a, _b;

      var spaceHash = js_sha256_1.sha256("".concat(space, ".3box"));
      var spacePath = (_b = (_a = spaceHash.match(/.{1,12}/g)) === null || _a === void 0 ? void 0 : _a.map(function (n) {
        return parseInt(n, 16).toString(2);
      }).map(function (n) {
        return "".concat(n.length === 47 ? '0' : '').concat(n);
      }).join('').match(/.{1,31}/g)) === null || _b === void 0 ? void 0 : _b.map(function (n) {
        return parseInt(n, 2);
      }).join("'/");

      var spaceNode = this._baseNode.derivePath("".concat(spacePath, "'"));

      this._spaceKeys[space] = this._deriveKeySet(spaceNode);
    }
  }, {
    key: "_getKeys",
    value: function _getKeys(space) {
      if (!space) {
        return this._rootKeys;
      } else if (!this._spaceKeys[space]) {
        if (this._migratedKeys) throw new Error('Can not derive space keys, not given in migrated keys');

        this._deriveSpaceKeys(space);
      }

      return this._spaceKeys[space];
    }
  }, {
    key: "asymEncrypt",
    value: function asymEncrypt(msg, toPublic) {
      var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
          nonce = _ref.nonce;

      return crypto_1.asymEncrypt(msg, toPublic, nonce);
    }
  }, {
    key: "asymDecrypt",
    value: function asymDecrypt(ciphertext, fromPublic, nonce) {
      var _ref2 = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {},
          space = _ref2.space,
          toBuffer = _ref2.toBuffer;

      var key = this._getKeys(space).asymEncryptionKey.secretKey;

      return crypto_1.asymDecrypt(ciphertext, fromPublic, key, nonce, toBuffer);
    }
  }, {
    key: "symEncrypt",
    value: function symEncrypt(msg) {
      var _ref3 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          space = _ref3.space,
          nonce = _ref3.nonce;

      return crypto_1.symEncryptBase(msg, this._getKeys(space).symEncryptionKey, nonce);
    }
  }, {
    key: "symDecrypt",
    value: function symDecrypt(ciphertext, nonce) {
      var _ref4 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
          space = _ref4.space,
          toBuffer = _ref4.toBuffer;

      return crypto_1.symDecryptBase(ciphertext, this._getKeys(space).symEncryptionKey, nonce, toBuffer);
    }
  }, {
    key: "managementPersonalSign",
    value: function managementPersonalSign(message) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var wallet;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                wallet = this.managementWallet();
                _context.next = 3;
                return wallet.signMessage(message);

              case 3:
                return _context.abrupt("return", _context.sent);

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    }
  }, {
    key: "managementWallet",
    value: function managementWallet() {
      var node = this._rootKeys.managementKey;
      return new wallet_1.Wallet(node.privateKey);
    }
  }, {
    key: "getJWTSigner",
    value: function getJWTSigner(space, useMgmt) {
      var pubkeys = this._getKeys(space);

      var key = useMgmt ? pubkeys.managementKey : pubkeys.signingKey;
      return did_jwt_1.EllipticSigner(key.privateKey.slice(2));
    }
  }, {
    key: "getRootSigner",
    value: function getRootSigner(keyId) {
      var _a, _b;

      var key = keyId === 'managementKey' ? (_a = this._rootKeys) === null || _a === void 0 ? void 0 : _a.managementKey : (_b = this._rootKeys) === null || _b === void 0 ? void 0 : _b.signingKey;

      if (key == null || !(key instanceof hdnode_1.HDNode)) {
        throw new Error('Invalid key');
      }

      return did_jwt_1.EllipticSigner(key.privateKey.slice(2));
    }
  }, {
    key: "getDBSalt",
    value: function getDBSalt(space) {
      return js_sha256_1.sha256(this._getKeys(space).signingKey.derivePath('0').privateKey.slice(2));
    }
  }, {
    key: "getPublicKeys",
    value: function getPublicKeys() {
      var _ref5 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          space = _ref5.space,
          uncompressed = _ref5.uncompressed,
          mgmtPub = _ref5.mgmtPub;

      var keys = this._getKeys(space);

      var signingKey = keys.signingKey.publicKey.slice(2);
      var managementKey = space ? null : mgmtPub && keys.managementKey.publicKey ? keys.managementKey.publicKey.slice(2) : keys.managementKey.address;

      if (uncompressed) {
        signingKey = ec.keyFromPublic(Buffer.from(signingKey, 'hex')).getPublic(false, 'hex');
      }

      return {
        signingKey: signingKey,
        managementKey: managementKey,
        asymEncryptionKey: tweetnacl_util_1.default.encodeBase64(keys.asymEncryptionKey.publicKey)
      };
    }
  }, {
    key: "serialize",
    value: function serialize() {
      return this._seed;
    }
  }], [{
    key: "encryptWithAuthSecret",
    value: function encryptWithAuthSecret(message, authSecret) {
      var node = hdnode_1.HDNode.fromSeed(ensure0x(authSecret)).derivePath(AUTH_PATH_ENCRYPTION);
      var key = utils_1.hexToUint8Array(node.privateKey.slice(2));
      return crypto_1.symEncryptBase(message, key);
    }
  }, {
    key: "decryptWithAuthSecret",
    value: function decryptWithAuthSecret(ciphertext, nonce, authSecret) {
      var node = hdnode_1.HDNode.fromSeed(ensure0x(authSecret)).derivePath(AUTH_PATH_ENCRYPTION);
      var key = utils_1.hexToUint8Array(node.privateKey.slice(2));
      return crypto_1.symDecryptBase(ciphertext, key, nonce);
    }
  }, {
    key: "walletForAuthSecret",
    value: function walletForAuthSecret(authSecret) {
      var node = hdnode_1.HDNode.fromSeed(ensure0x(authSecret)).derivePath(AUTH_PATH_WALLET);
      return new wallet_1.Wallet(node.privateKey);
    }
  }]);

  return Keyring;
}();

exports.default = Keyring;